import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';
import { SymbolDetailsResponse } from './symbol-details.interfaces';

@Injectable({
  providedIn: 'root'
})
export class SymbolDetailsService {

  constructor(
    private http: HttpClient,
    private confService: ConfigurationService
  ) { }

  getStaticData(symbols: any[]) {
    return this.http.post<SymbolDetailsResponse[]>(this.confService.applicationUrls.symbolData, symbols);
  }
}
